export default function initM3() {
    jQuery(".brandSLider").slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.brandSliderSingle',
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '100px',
                }
            }
        ]
    })
    jQuery(".brandSliderSingle").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.brandSLider',
        centerMode: true,
        centerPadding: '100px',
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    centerPadding: '0px',
                }
            }
        ]
    })
}